@if (isVisible()) {
  <mat-toolbar class="controls">
    @if (breadcrumbs.length > 0) {
      <div id="breadcrumb-container" class="breadcrumbs">
        @if (!isMobile) {
          @if (!shouldTruncateBreadcrumbs()) {
            @for (bc of breadcrumbs; track bc.id; let first = $first; let last = $last) {
              @if (!first) {
                <span #breadcrumbItem>&nbsp;/&nbsp;</span>
              }
              @if (!last) {
                <button #breadcrumbItem (click)="itemClicked(bc)" class="breadcrumb">{{ bc.name }}</button>
              }
              @if (last) {
                <span #breadcrumbItem class="current-location" class="current-location">{{ bc.name }}</span>
              }
            }
          } @else {
            <button class="breadcrumb" (click)="itemClicked(breadcrumbs[0])">{{breadcrumbs[0].name}}</button>
            <span>&nbsp;/&nbsp;</span>
            <button [matMenuTriggerFor]="breadcrumbMenu" class="breadcrumb">...</button>
            <span>&nbsp;/&nbsp;</span>
            <span class="current-location">{{breadcrumbs[breadcrumbs.length-1].name}}</span>
          }
          <mat-menu #breadcrumbMenu="matMenu">
            @for (bc of breadcrumbs; track bc.id; let first = $first; let last = $last) {
              @if (!last && !first) {
                <button mat-menu-item (click)="itemClicked(bc)" class="menu-breadcrumb">
                  <span>
                    {{ bc.name }}
                  </span>
                </button>
              }
            }
          </mat-menu>
        }
        @if (breadcrumbs.length > 1 && isMobile) {
          <button class="back-button" (click)="itemClicked(breadcrumbs[breadcrumbs.length - 2])">
            <fa-icon [icon]="['far', 'arrow-left']"></fa-icon>
            <span>Back</span>
          </button>
        }
        @if (breadcrumbs.length === 1 && isMobile) {
          <span class="current-location">{{ breadcrumbs[0].name }}</span>
        }
      </div>
    }
    <div class="buttons_selects">
      @if (getButtons() && getButtons().length > 0) {
        <div class="buttons">
          @for (bc of getButtons(); track bc.id) {
            <button class="control" [class.control-hover]="!isDDorCollections()" (click)="itemClicked(bc)">
              @if (bc.icon) {
                <fa-icon [icon]="iconService.getFaIcon(bc.icon)"></fa-icon>
              }
              {{bc.name}}
              @if (bc.count && bc.count > 0) {
                <span>({{bc.count}})</span>
              }
            </button>
          }
        </div>
      }
      @if (getSelects() && getSelects().length > 0) {
        <div class="selects">
          @for (sel of getSelects(); track sel.id) {
            @if (getSelectDisplayValue(sel); as displayValue) {
              <button
                #matMenuTrigger
                class="control"
                [matMenuTriggerFor]="secondary"
                [class.control-hover]="!isDDorCollections()"
                >
                @if (displayValue.icon) {
                  <fa-icon [icon]="iconService.getFaIcon(displayValue.icon)"></fa-icon>
                }
                {{displayValue.name}}
                @if (displayValue.count && displayValue.count > 0) {
                  <span>({{displayValue.count}})</span>
                }
                <fa-icon [icon]="['fas', 'chevron-down']"></fa-icon>
              </button>
            }
            <mat-menu #secondary="matMenu">
              <div class="mat-menu">
                <div class="subMenuItems">
                  @for (child of sel.subMenuItems; track child.id) {
                    <button (click)="itemOptionSelected(sel, child)" mat-menu-item>
                      <span>
                        @if (child.icon) {
                          <fa-icon [icon]="iconService.getFaIcon(child.icon)"></fa-icon>
                        }
                        {{child.name}}
                        @if (child.count && child.count > 0) {
                          <span>({{child.count}})</span>
                        }
                      </span>
                    </button>
                    @if (child.subMenuItems) {
                      @for (nested of child.subMenuItems; track nested.id) {
                        <ng-container *ngTemplateOutlet="childMenus; context: {$implicit: nested}"></ng-container>
                      }
                      <ng-template #childMenus let-menu>
                        <div class="subMenuItems">
                          @if (!menu.subMenuItems) {
                            <button (click)="itemOptionSelected(sel, menu)" mat-menu-item>
                              <span>
                                @if (menu.icon) {
                                  <fa-icon [icon]="iconService.getFaIcon(menu.icon)"></fa-icon>
                                }
                                {{menu.name}}
                                @if (menu.count && menu.count > 0) {
                                  <span>({{menu.count}})</span>
                                }
                              </span>
                            </button>
                          }
                          <ng-container>
                            @for (child of menu.subMenuItems; track child.id) {
                              <ng-container *ngTemplateOutlet="childMenus; context: {$implicit: menu}"></ng-container>
                            }
                          </ng-container>
                        </div>
                      </ng-template>
                    }
                  }
                </div>
              </div>
            </mat-menu>
          }
        </div>
      }
    </div>
  </mat-toolbar>
}
